import Util from '../../Common/Util';
import LayoutData from './LayoutData';

/** 플라이아웃 헤더(= 메뉴 한 칸) 높이 — vendors/_adminlte.scss 의 $sidebar-flyout-head 와 같은 값 */
const FLY_HEAD = 46.85;
/** 플라이아웃이 화면 위·아래에 남겨 두는 여백 */
const FLY_GAP = 8;

export default class Menu {
    init(){
        this.render();
        this.bindFlyout();
    }
    /**
     * 사이드바 메뉴 JS 렌더링
     */
    render(){
        const menu = LayoutData.get('menu', null);
        if(!menu) return;

        var $ul = $('#admin-sidebar-menu');
        if(!$ul.length) return;

        var html = '';
        $.each(menu, function(i, v){
            var icon = Util.escapeHtml(v.icon || (v.depth == 1 ? 'nav-icon fas fa-th' : 'far fa-circle nav-icon'));
            // 메뉴 설정값(이름·주소)은 관리자 입력 — 서식 HTML 을 쓰지 않으므로 글자로만 넣는다
            var title = Util.escapeHtml(v.title);
            var url = Util.escapeHtml(v.url || '');

            // 다음 항목이 중메뉴(depth 2)면 이 대메뉴는 서브메뉴를 가짐.
            // (url 유무가 아니라 자식 존재로 판정 → url 있어도 서브메뉴 유지)
            var next = menu[i + 1];
            var hasChildren = (v.depth == 1 && next && next.depth == 2);

            // 대메뉴 닫기
            if(v.is_close){
                html += '</ul></li>';
            }

            // 대메뉴 단독 (자식 없음) — url 없으면 '#'
            if(v.depth == 1 && !hasChildren){
                html += '<li class="nav-item">'
                    +   '<a href="'+ (url || '#') +'" class="nav-link">'
                    +     '<i class="nav-icon '+ icon +'"></i>'
                    +     '<p>'+ title +'</p>'
                    +   '</a>'
                    + '</li>';
            }

            // 대메뉴 열기 (자식 있음) — url 있으면 대메뉴 클릭 시 링크 이동
            if(v.depth == 1 && hasChildren){
                var parentCls = 'nav-link' + (v.url ? ' js-parent-link' : '');
                html += '<li class="nav-item nav_select">'
                    +   '<a href="'+ (url || '#') +'" class="'+ parentCls +'">'
                    +     '<i class="nav-icon '+ icon +'"></i>'
                    +     '<p>'+ title +'<i class="right fas fa-angle-left"></i></p>'
                    +   '</a>'
                    +   '<ul class="nav nav-treeview">';
            }

            // 중메뉴 (depth 2)
            if(v.depth == 2){
                html += '<li class="nav-item"><a href="'+ url +'" class="nav-link"><p>'+ title +'</p></a></li>';
            }

            // 마지막 닫기
            if(v.is_last_close){
                html += '</ul></li>';
            }
        });

        $ul.html(html);

        // 불러톡(좌측 메뉴) 은 팝업 대신 인라인 패널로 — DB url(javascript:openChatWindow())을 코드에서 치환.
        // (상단 헤더 채팅 아이콘은 blade 에서 팝업(Util.chatList) 그대로 유지 — 사이드바 메뉴만 대상)
        // 검색 토큰(openChatWindow())은 DB 에 저장된 값이라 바꾸지 않는다 — 치환 결과만 패널 열기로.
        $ul.find('a[href="javascript:openChatWindow()"]').attr('href', 'javascript:$j.F.Admin.ChatPanel.open()');

        // url 을 가진 대메뉴(서브메뉴 보유)는 클릭 시 treeview 토글 대신 링크 이동.
        // 앵커에 직접 바인딩해 이벤트가 treeview 루트(ul)로 버블링되기 전에 차단
        // → AdminLTE 토글 핸들러 미실행, preventDefault 없이 기본 href 이동 수행.
        // 단, 모바일(AdminLTE 모바일 폭 992px 미만)은 예외 — 폰은 hover 플라이아웃이 없어
        // 서브메뉴를 볼 길이 treeview 토글뿐이므로 그대로 버블링시켜 토글(서브메뉴 펼침)에 맡긴다.
        // PC(992px 이상)는 접힘·펼침 상태와 무관하게 링크 이동 그대로.
        $ul.find('.js-parent-link').on('click', function(e){
            if(window.matchMedia('(max-width: 991.98px)').matches) return;
            e.stopPropagation();
        });

        this.setDatas();
        this.setUserInfo();
    }

    /**
     * 접힘 사이드바의 호버 플라이아웃이 화면 아래로 잘리지 않게 위로 끌어올린다.
     *
     * 플라이아웃은 대메뉴 칸에 붙어 **아래로만** 자란다. 그래서 화면이 낮으면 아래쪽
     * 대메뉴(설정·로그처럼 자식이 많은 것)의 서브메뉴 끝이 뷰포트 밖으로 나간다 —
     * 사이드바가 fixed 라 스크롤해서 볼 수도 없다.
     */
    bindFlyout(){
        const $ul = $('#admin-sidebar-menu');

        $ul.on('mouseenter', '> .nav-item', (e) => this.placeFlyout(e.currentTarget));
        $ul.on('mouseleave', '> .nav-item', (e) => this.clearFlyout(e.currentTarget));
    }

    /**
     * ⚠ 좌표계가 둘이다. getBoundingClientRect 는 zoom(글자크기)이 반영된 **뷰포트** px 이고,
     *   top 에 넣는 값은 zoom 이 걸리기 전의 **로컬** px 이다 (base/_fontsize.scss 머리말).
     *   그래서 뷰포트에서 잰 보정량은 배율로 나눠서 돌려준다.
     */
    placeFlyout(item){
        this.clearFlyout(item);

        // 펼침 상태·모바일 폭에는 플라이아웃 자체가 없다
        if(!document.body.classList.contains('sidebar-collapse')) return;
        if(window.matchMedia('(max-width: 991.98px)').matches) return;

        const tree = item.querySelector(':scope > .nav-treeview');
        if(!tree) return;   // 라벨만 뜨는 단독 메뉴는 메뉴 칸과 높이가 같아 넘칠 일이 없다

        const zoom  = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--adm-zoom')) || 1;
        const top   = item.getBoundingClientRect().top;
        const head  = FLY_HEAD * zoom;
        const body  = this.flyoutHeight(tree);
        const limit = window.innerHeight - FLY_GAP;

        const over = (top + head + body) - limit;
        if(over <= 0) return;

        // 위로 끌어올리되 화면 위로는 넘기지 않는다
        const lift = Math.min(over, Math.max(0, top - FLY_GAP));
        if(lift > 0) item.style.setProperty('--adm-fly-top', (-lift / zoom) + 'px');

        // 끝까지 올려도 모자라면 서브메뉴만 스크롤시킨다
        const room = limit - (top - lift + head);
        if(body > room) item.style.setProperty('--adm-fly-maxh', (room / zoom) + 'px');
    }

    /**
     * 서브메뉴의 펼친 높이(뷰포트 px).
     * mouseenter 시점에 :hover 가 아직 안 걸렸으면 0 이 나오므로, 그때만 잠깐 펼쳐서 잰다.
     * 같은 태스크 안에서 되돌리므로 화면에는 그려지지 않는다.
     */
    flyoutHeight(tree){
        let h = tree.getBoundingClientRect().height;
        if(h) return h;

        tree.style.setProperty('display', 'block', 'important');
        h = tree.getBoundingClientRect().height;
        tree.style.removeProperty('display');
        return h;
    }

    clearFlyout(item){
        item.style.removeProperty('--adm-fly-top');
        item.style.removeProperty('--adm-fly-maxh');
    }

    /**
     * adminlte에서 제공하는 active on/off
     */
    setDatas(){
        // 현재 페이지 추출
        const currentPageUrl = window.location.href
        let currentPageSplitUrl = currentPageUrl.split("/")
        let currentPageSplitUrlLength = currentPageSplitUrl.length
        let currentPageLastFileName = currentPageSplitUrl[currentPageSplitUrlLength-1]
        // 모든 아이템에 active 제거했다가 현재 페이지와 맞으면 해당 아이템에 active 추가
        let navItems = document.querySelectorAll('.nav-item a')
        navItems.forEach(function(item){
            item.classList.remove('active');
            let linkUrls = item.getAttribute('href')
            if(linkUrls == currentPageLastFileName){
                item.classList.add('active')
            }

            let navSelects = document.querySelectorAll(".nav_select");
            navSelects.forEach(function(selectitem){
                let selectChild = selectitem.querySelector(".nav-item a.active");
                // console.log(selectChild);
                if(selectChild !== null){
                    selectitem.querySelector("a").classList.add("active");
                    selectitem.classList.add("menu-open");
                }else{
                    selectitem.querySelector("a").classList.remove("active");
                }
            })
        });
    }


    /**
     * 헤더 사용자 정보 렌더링
     */
    setUserInfo(){
        const userName = LayoutData.get('userName'), appVer = LayoutData.get('appVer'),
              storeUrl = LayoutData.get('storeUrl'), pageTitle = LayoutData.get('pageTitle');
        if(userName !== undefined){
            $('#admin-username-header').text(userName + '님 안녕하세요');
        }
        if(appVer !== undefined){
            $('#admin-appver-header').text('v' + appVer);
        }
        if(storeUrl !== undefined){
            $('#admin-playstore-link').attr('href', storeUrl);
        }
        if(pageTitle !== undefined){
            $('#admin-page-title').text(pageTitle);
        }
    }

}